import React from "react";

type ArrowProps = {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
};

function NextArrow({ className, style, onClick }: ArrowProps) {
  return (
    <div
      className={className}
      onClick={onClick}
      style={{ ...style, fontSize: 0,
      lineHeight: 0,
      position: "absolute",
      top: "50%",
      display: "block",
      width: "30px",
      height: "30px",
      padding: 0,
      transform: "translate(0, -50%)",
      cursor: "pointer",
      color: "transparent",
      border: "none",
      outline: "none",
      background: "transparent",
      zIndex: 1,
      right: "0px"}}
    >
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="14.5" transform="rotate(-180 15 15)" fill="#18468F" stroke="#18468F"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M12.2366 9.21967C12.5624 8.92678 13.0907 8.92678 13.4165 9.21967L19.2568 14.4697C19.5826 14.7626 19.5826 15.2374 19.2568 15.5303L13.4165 20.7803C13.0907 21.0732 12.5624 21.0732 12.2366 20.7803C11.9107 20.4874 11.9107 20.0126 12.2366 19.7197L17.4869 15L12.2366 10.2803C11.9107 9.98744 11.9107 9.51256 12.2366 9.21967Z" fill="white"/>
        </svg>
    </div>
 );
}

export default NextArrow;
